import { PERMANENT_COOKIE_NAME } from '@packages/domain/constants/cookies';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { logger } from 'services/logger/logger';
import { cookies } from 'utils/cookies/cookies';

type NotFoundSource = 'not_found' | 'fallback' | 'default_fallback';

const useNotFoundLogger = (
  search: string,
  pathname: string,
  source: NotFoundSource,
  error?: Error,
) => {
  useEffect(() => {
    const referrer = document.referrer;

    let searchDecodable = true;
    try {
      decodeURIComponent(search);
    } catch {
      searchDecodable = false;
    }

    const peerTrackerId = cookies.read(PERMANENT_COOKIE_NAME);

    logger.log({
      description: 'not_found_page_rendered',
      parameters: {
        pathname: `${pathname}${search}`,
        search_decodable: searchDecodable,
        search_length: search.length,
        referrer,
        source,
        peer_tracker_id: peerTrackerId || null,
        error_message: error?.message ?? null,
        error_name: error?.name ?? null,
        error_stack_top: error?.stack?.split('\n')[1]?.trim() ?? null,
      },
    });

    if (pathname.includes('/pay/payment')) {
      Sentry.withScope(scope => {
        scope.setTag('pathname', pathname);
        scope.setTag('peer_tracker_id', peerTrackerId ?? '');
        Sentry.captureException(
          new Error(`not_found_page_rendered: ${source}`),
        );
      });
    }
  }, []);
};

export { useNotFoundLogger };
